export default __webpack_public_path__ + "static/ai-cold-call-quality-assurance-aab3aefc964250f0a35d0794fd07156f.jpg";